import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Briefcase, GraduationCap, Plus, Trash2 } from 'lucide-react';

export const Step4ExpEdu = ({
  formData,
  handleAddExperience, handleUpdateExperience, handleRemoveExperience,
  handleAddEducation, handleUpdateEducation, handleRemoveEducation,
}) => (
  <div className="space-y-8">
    <div className="text-center mb-8">
      <h2 className="text-2xl font-bold text-white mb-2">Experiência & Formação</h2>
      <p className="text-gray-400">Sua trajetória profissional</p>
    </div>

    {/* Experiences */}
    <div>
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm text-gray-400 flex items-center">
          <Briefcase className="w-4 h-4 mr-2" />
          Experiência Profissional
        </label>
        <Button onClick={handleAddExperience} size="sm" variant="outline" className="border-zinc-700">
          <Plus className="w-4 h-4 mr-1" /> Adicionar
        </Button>
      </div>

      {formData.experiences.map((exp, idx) => (
        <Card key={exp._key || idx} className="bg-zinc-800/50 border-zinc-700 mb-3">
          <CardContent className="p-4 space-y-3">
            <div className="flex justify-between">
              <Input
                value={exp.title}
                onChange={(e) => handleUpdateExperience(idx, 'title', e.target.value)}
                placeholder="Cargo"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleRemoveExperience(idx)}
                className="text-red-400 hover:text-red-300"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <Input
              value={exp.company}
              onChange={(e) => handleUpdateExperience(idx, 'company', e.target.value)}
              placeholder="Empresa"
              className="bg-zinc-800 border-zinc-700 text-white"
            />
            <div className="grid grid-cols-2 gap-3">
              <Input
                type="month"
                value={exp.start_date}
                onChange={(e) => handleUpdateExperience(idx, 'start_date', e.target.value)}
                placeholder="Início"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
              <Input
                type="month"
                value={exp.end_date}
                onChange={(e) => handleUpdateExperience(idx, 'end_date', e.target.value)}
                placeholder="Término"
                className="bg-zinc-800 border-zinc-700 text-white"
                disabled={exp.is_current}
              />
            </div>
            <label className="flex items-center text-sm text-gray-400">
              <input
                type="checkbox"
                checked={exp.is_current}
                onChange={(e) => handleUpdateExperience(idx, 'is_current', e.target.checked)}
                className="mr-2"
              />
              Trabalho atual
            </label>
          </CardContent>
        </Card>
      ))}
    </div>

    {/* Education */}
    <div>
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm text-gray-400 flex items-center">
          <GraduationCap className="w-4 h-4 mr-2" />
          Formação Acadêmica
        </label>
        <Button onClick={handleAddEducation} size="sm" variant="outline" className="border-zinc-700">
          <Plus className="w-4 h-4 mr-1" /> Adicionar
        </Button>
      </div>

      {formData.education.map((edu, idx) => (
        <Card key={edu._key || idx} className="bg-zinc-800/50 border-zinc-700 mb-3">
          <CardContent className="p-4 space-y-3">
            <div className="flex justify-between">
              <Input
                value={edu.institution}
                onChange={(e) => handleUpdateEducation(idx, 'institution', e.target.value)}
                placeholder="Instituição"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleRemoveEducation(idx)}
                className="text-red-400 hover:text-red-300"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Input
                value={edu.degree}
                onChange={(e) => handleUpdateEducation(idx, 'degree', e.target.value)}
                placeholder="Grau (Bacharelado, Mestrado...)"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
              <Input
                value={edu.field_of_study}
                onChange={(e) => handleUpdateEducation(idx, 'field_of_study', e.target.value)}
                placeholder="Área de estudo"
                className="bg-zinc-800 border-zinc-700 text-white"
              />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default Step4ExpEdu;
